export const required = value => (value ? undefined : 'required');
export const number = value =>
    value && isNan(Number(value)) ? 'Value must be a number' : undefined;
export const maxValue = max => value =>
    value && value > max ? `The maximum amount is ${max}` : undefined;
export const minLength = (length, name) => value =>
    value && value.length < length
        ? `must be at least ${length} characters long`
        : undefined;
export const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? 'please enter a correct email'
        : undefined;
export const matchPass = (value, allValues) => {
    let isMatch = false;
    if (allValues.newpassword) isMatch = value !== allValues.newpassword;
    else isMatch = value !== allValues.password;

    return isMatch ? 'the password did not match' : undefined;
};



// WEBPACK FOOTER //
// ./src/utils/validators.js